<template>
	<div class="policySearch">
		<div class="policySearchCon">
			<searchBox :type='3' place='输入关键字' @search='search' ref="childRef"></searchBox>
			
			<div class="center">
				<div class="nodata" v-if="list.length==0">
					<no-Data></no-Data>
				</div>
				<policyItem :list='list'></policyItem>
			</div>
			
			<div v-if="total>limit" class="page">
				<el-pagination background :page-size="limit" layout="prev, pager, next" :total="total"
					@current-change='changePage'>
				</el-pagination>
			</div>

		</div>
	</div>
</template>

<script>
	import searchBox from '@/components/searchBox.vue'
	import policyItem from '@/components/policyItem.vue'
	export default {
		name: 'policy',
		components: {
			searchBox,
			policyItem
		},
		data() {
			return {
				loading: false,
				list: [],
				id:'',
				page:1,
				total:0,
				limit:12,
				title:''
			}
		},
		created() {
			this.id=this.$route.query.id
			this.title=this.$route.params.title
			this.getList()
		},
		mounted() {
			this.$refs.childRef.childMethod(this.$route.params.title);
		},
		methods: {
			// 获取列表
			getList() {
				this.loading = true
				let data = {
					page: this.page,
					limit: this.limit,
					second_class_id:this.id,
					title:this.title
				}
				this.$axios.get('/api/client/Policy/getPolicy', {
					params: data
				}).then(res => {
					this.loading = false
					if (res.code == 200) {
						this.total = res.data.total
						this.list = res.data.data
					} else {
						this.$eltips(res.msg, 'error')
					}
				})
			},
			changePage(e) {
				console.log(e, '---e')
				this.page = e
				this.getList()
			},
			search(value){
				this.title=value
				this.page=1
				this.getList()
			}
		}
	}
</script>

<style lang="scss" scoped>
	.policySearch {
		position: relative;
		.page {
			display: flex;
			align-items: center;
			justify-content: center;
			margin: 48px 0 0;
		}

		.policySearchCon {
			position: relative;
			z-index: 2;
			width: 1200px;
			margin: 0 auto;
			padding: 48px 0;
			
			.center{
				height: 520px;
				.nodata{
					height: 520px;
					border-radius: 16px;
					background: #FFF;
				}
			}
			
		}
	}
</style>